/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Nav Bar Tabs.
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { useAuth0 } from "@auth0/auth0-react";
import UserService from "../../../services/UserService";
import { releaseAndLogout } from "../../../utils/logout";

export default function NavTabs() {
  const { user, isAuthenticated, logout, getAccessTokenSilently } = useAuth0();
  const [profileFirstName, setProfileFirstName] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadUser = async () => {
      try {
        if (!isAuthenticated) return;
        const token = await getAccessTokenSilently();
        const data = await UserService.user(token);
        if (isMounted) {
          setProfileFirstName(
            data?.firstName || data?.givenName || data?.given_name || user?.given_name || null
          );
        }
      } catch (e) {
        if (isMounted) {
          setProfileFirstName(user?.given_name || null);
        }
      }
    };
    loadUser();
    return () => { isMounted = false; };
  }, [isAuthenticated, getAccessTokenSilently, user]);

  const logoutWithRedirect = () => releaseAndLogout(logout);

  return (
    <div className="fl-tabs">
      <div className="fl-tabs__inner">
        {/* Left area intentionally empty to match screenshot (logo/brand lives elsewhere) */}
        <div className="fl-tabs__left" />

        {/* Right utilities: Hello | Log Out | FAQ | [cog] */}
        <div className="fl-tabs__right">
                {isAuthenticated && (
                    <span className="fl-hello" style={{ fontWeight: 300 }}>Hello {profileFirstName || user?.given_name || user?.name}</span>
                )}
                      <span className="fl-sep" aria-hidden>|</span>
            <a 
              href="#" 
              className="fl-link" 
              onClick={(e) => {
                e.preventDefault();
                logoutWithRedirect();
              }}
              style={{ textDecoration: 'none', fontWeight: 300 }}
            >
              Log Out
            </a>
            <a 
              href="https://farelanes.com/frequently-asked-questions/" 
              className="fl-link" 
              rel="noreferrer" 
              target="_blank" 
              style={{ textDecoration: 'none', fontWeight: 300 }}
            >
              FAQ
            </a>
            <a
              className="fl-icon"
              href="https://farelanes.com/account"
              rel="noreferrer"
              style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
              title="Account"
            >
              <FontAwesomeIcon icon={faCog} style={{ fontSize: '16px', opacity: 0.7, filter: 'contrast(0.8)' }} />
            </a>
        </div>
      </div>
    </div>
  );
}
